export default "__VITE_ASSET__70323457__"